import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ButtonAppBar, ClassicDrawer, Notifications } from "./components";
import { useNotification } from "./hooks";
import {
  MagCaricoUscita,
  MagRilevaColli,
  Login,
  MagRilevaColliMisure,
  NotFound,
  MagCaricoUscitaViaggio,
  MagPosizionamentoEntrata,
  MagPosizionamentoEntrataDettaglio,
  MagPosizionamentoUscitaDettaglio,
  MagInventario,
  MagInventarioDettaglio,
  MagArrivoTrazione,
  MagArrivoTrazioneDettaglio,
  MagPartenzaTrazione,
  MagPartenzaTrazioneDettaglio,
  MagAssegnazioneSSCCtoRifPaletta,
  MagPartenzaDistribuzione,
  MagPartenzaDistribuzioneDettaglio,
  MagInventarioHub,
  MagInventarioHubDettaglio,
  MagControlloColliQualita,
  MagControlloColliQualitaDettaglio,
  MagRientroDistribuzione,
  MagRientroDistribuzioneDettaglio,
  MagCaricoUscitaCambioViaggio,
  MagLogEntrata,
  MagLogEntrataDettaglio,
  MagLogUscita,
  MagLogUscitaDettaglio,
  MagArrivoDistinta,
  MagArrivoDistintaDettaglio,
  MagLogEntrataUBI,
  MagLogEntrataUBIDettaglio ,
  MagLogUscitaUBI,
  MagLogUscitaUBIDettaglio, 
  MagViaggiCustomDettaglio,
  MagAssegnazioneUbicazionetoRifPaletta,
  MagLogCustom,
  MagLogCustomDettaglio,
  InfoBarcode
} from "./pages";
import Home from "./pages/Home";
import MagPosizionamentoUscita from "./pages/MagPosizionamentoUscita";
import MagViaggiCustom from "./pages/MagViaggiCustom";

const Main = () => {
  const [notifications, closeNotification] = useNotification();


  return (
    <>
      {notifications.length > 0 && (
        <Notifications
          notifications={notifications}
          closeNotification={closeNotification}
        />
      )}
      <Router>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Login />} />

          <Route
            path="/home"
            element={
              <>
                <ButtonAppBar></ButtonAppBar>
                <Home />
              </>
            }
          />

          <Route
            path="/rileva-colli"
            element={
              <>
                <ClassicDrawer
                  component={<MagRilevaColli />}
                  title="Lettura barcode"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/misure-colli/:code"
            element={
              <>
                <ClassicDrawer
                  component={<MagRilevaColliMisure />}
                  title="Misure colli"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/carico-merce-in-uscita"
            element={
              <>
                <ClassicDrawer
                  component={<MagCaricoUscita />}
                  title="Carico merce in uscita"
                ></ClassicDrawer>
              </>
            }
          />

          < Route
            path="/carico-merce-in-uscita/cambio-viaggio/:idviaggio/:idsped"
            element={
              <>
                <ClassicDrawer
                  component={<MagCaricoUscitaCambioViaggio />}
                  title="Cambio viaggio"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/carico-merce-in-uscita/:idviaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagCaricoUscitaViaggio />}
                  title="Viaggio"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/posizione-merce-mag-entrata"
            element={
              <>
                <ClassicDrawer
                  component={<MagPosizionamentoEntrata />}
                  title="Posizionamento merce entrata"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/posizione-merce-mag-entrata/:idMerce"
            element={
              <>
                <ClassicDrawer
                  component={<MagPosizionamentoEntrataDettaglio />}
                  title="Merce in entrata"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/viaggi-custom/:codiceMenu"
            element={
              <>
                <ClassicDrawer
                  component={<MagViaggiCustom />}
                  title="Ricerca viaggi"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/assegnazione-ubicazione-to-rifpaletta/:codiceMenu"
            element={
              <>
                <ClassicDrawer
                  component={<MagAssegnazioneUbicazionetoRifPaletta />}
                  title="Spostamento interno"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/viaggi-custom-detail/:codiceMenu/:idBarcodeViaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagViaggiCustomDettaglio />}
                  title="Dettaglio viaggio"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/merce-mag-log-entrata"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogEntrata />}
                  title="Movimenti in entrata"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/merce-mag-log-entrata-dettaglio/:prgMovimento"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogEntrataDettaglio />}
                  title="Dettaglio movimento in entrata"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/merce-mag-log-entrata-ubi"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogEntrataUBI />}
                  title="Movimenti in entrata per magazzino ubicazioni"
                ></ClassicDrawer>
              </>
            }
          />      

          <Route
            path="/merce-mag-log-entrata-ubi-dettaglio/:PrgMovimento"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogEntrataUBIDettaglio />}
                  title="Movimenti in entrata per magazzino ubicazioni"
                ></ClassicDrawer>
              </>
            }
          />      

          <Route
            path="/merce-mag-log-uscita"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogUscita />}
                  title="Movimenti in uscita"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/merce-mag-log-uscita-dettaglio/:prgMovimento"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogUscitaDettaglio />}
                  title="Dettaglio movimento in uscita"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/merce-mag-log-uscita-ubi"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogUscitaUBI />}
                  title="Movimenti in uscita per magazzino ubicazioni"
                ></ClassicDrawer>
              </>
            }
          />      

          <Route
            path="/merce-mag-log-uscita-ubi-dettaglio/:PrgMovimento"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogUscitaUBIDettaglio />}
                  title="Movimenti in uscita per magazzino ubicazioni"
                ></ClassicDrawer>
              </>
            }
          />  

          <Route
            path="/posizione-merce-mag-uscita"
            element={
              <>
                <ClassicDrawer
                  component={<MagPosizionamentoUscita />}
                  title="Posizionamento merce uscita"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/posizione-merce-mag-uscita/:idMerce"
            element={
              <>
                <ClassicDrawer
                  component={<MagPosizionamentoUscitaDettaglio />}
                  title="Merce in uscita"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/inventario-magazzino"
            element={
              <>
                <ClassicDrawer
                  component={<MagInventario />}
                  title="Inventario magazzino"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/inventario-magazzino/:idInventario"
            element={
              <>
                <ClassicDrawer
                  component={<MagInventarioDettaglio />}
                  title="Inventario"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/partenza-distribuzione"
            element={
              <>
                <ClassicDrawer
                  component={<MagPartenzaDistribuzione />}
                  title="Partenza per distribuzione"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/partenza-distribuzione/:idBarcodeViaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagPartenzaDistribuzioneDettaglio />}
                  title="Partenza per distribuzione"
                  canClose={true}
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/arrivo-da-trazione"
            element={
              <>
                <ClassicDrawer
                  component={<MagArrivoTrazione />}
                  title="Arrivo da trazione"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/arrivo-distinta"
            element={
              <>
                <ClassicDrawer
                  component={<MagArrivoDistinta />}
                  title="Arrivo per distinta"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/arrivo-distinta/:idBarcodeDistinta"
            element={
              <>
                <ClassicDrawer
                  component={<MagArrivoDistintaDettaglio />}
                  title="Arrivo per distinta"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/arrivo-da-trazione/:idBarcodeViaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagArrivoTrazioneDettaglio />}
                  title="Arrivo da trazione"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/partenza-per-trazione"
            element={
              <>
                <ClassicDrawer
                  component={<MagPartenzaTrazione />}
                  title="Partenza per trazione"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/partenza-per-trazione/:idBarcodeViaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagPartenzaTrazioneDettaglio />}
                  title="Partenza per trazione"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/assegnazione-sscc-to-rifpaletta"
            element={
              <>
                <ClassicDrawer
                  component={<MagAssegnazioneSSCCtoRifPaletta />}
                  title="Assegnazione SSCC"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/inventario-hub"
            element={
              <>
                <ClassicDrawer
                  component={<MagInventarioHub />}
                  title="Inventario HUB"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/inventario-hub/:idInventarioHub"
            element={
              <>
                <ClassicDrawer
                  component={<MagInventarioHubDettaglio />}
                  title="Inventario HUB"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/cerca-colli-controllo-qualita"
            element={
              <>
                <ClassicDrawer
                  component={<MagControlloColliQualita />}
                  title="Cerca colli per controllo qualità"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/cerca-colli-controllo-qualita/:idColloQualita"
            element={
              <>
                <ClassicDrawer
                  component={<MagControlloColliQualitaDettaglio />}
                  title="Controllo qualità"
                ></ClassicDrawer>
              </>
            }
          />
          <Route
            path="/rientro-da-distribuzione"
            element={
              <>
                <ClassicDrawer
                  component={<MagRientroDistribuzione />}
                  title="Rientro da distribuzione"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/rientro-da-distribuzione/:idBarcodeViaggio"
            element={
              <>
                <ClassicDrawer
                  component={<MagRientroDistribuzioneDettaglio />}
                  title="Rientro da distribuzione"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/magazzino-movimenti-custom/:codiceMenu"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogCustom />}
                  title="Ricerca movimenti"
                ></ClassicDrawer>
              </>
            }
          />

          <Route
            path="/merce-mag-log-custom-dettaglio/:codiceMenu/:prgMovimento"
            element={
              <>
                <ClassicDrawer
                  component={<MagLogCustomDettaglio />}
                  title="Dettaglio movimento"
                ></ClassicDrawer>
              </>
            }
          />
          
          <Route
            path="/info-barcode/:codiceMenu"
            element={
              <>
                <ClassicDrawer
                  component={<InfoBarcode />}
                  title="Informazioni su Barcode"
                ></ClassicDrawer>
              </>
            }
          />

        </Routes>
      </Router>
    </>
  );
};

export default Main;
